import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant'
import 'vant/lib/index.css'
import { Table, TableColumn, Empty } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/index.scss'
import './styles/vant.scss'
import plugins from './plugins/index'
import './permission'
import * as filters from './filters'

Vue.use(Vant)

Vue.use(plugins)

Vue.use(Table)

Vue.use(TableColumn)

Vue.use(Empty)

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.config.productionTip = false

// import VConsole from 'vconsole'
// new VConsole()

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
